"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContingencyTable = exports.groupOptionsByExpiry = exports.getAdjustStrikesPositions = void 0;
const types_1 = require("../types");
const calculationUtils_1 = require("./calculationUtils");
const getAdjustStrikesPositions = (options, tickers) => {
    const underyingPrice = options.length > 0 ? tickers[options[0].instrument].underlyingPrice : -1;
    return options.map((option) => {
        const originalStrike = (0, calculationUtils_1.getOptionInstrumentStrike)(option.instrument);
        const amount = option.amount;
        const adjastedAmount = calculateAdjustedStrikePositions(amount, originalStrike, underyingPrice);
        return Object.assign(Object.assign({}, option), { tradeInformation: Object.assign(Object.assign({}, option), { amount: adjastedAmount }) });
    });
};
exports.getAdjustStrikesPositions = getAdjustStrikesPositions;
const groupOptionsByExpiry = (options) => {
    return options.reduce((memo, current) => {
        const expiry = (0, calculationUtils_1.getInstrumentExpiry)(current.instrument);
        if (memo[expiry]) {
            memo[expiry].push(current);
        }
        else {
            memo[expiry] = [current];
        }
        return memo;
    }, {});
};
exports.groupOptionsByExpiry = groupOptionsByExpiry;
const getContingencyTable = (options) => {
    const contingencyTable = {};
    for (const option of options) {
        const strike = (0, calculationUtils_1.getOptionInstrumentStrike)(option.instrument);
        const optionType = (0, calculationUtils_1.getOptionType)(option.instrument);
        const amount = option.amount;
        if (contingencyTable[`${strike}`]) {
            contingencyTable[`${strike}`][optionType] += amount;
            contingencyTable[`${strike}`].netPosition += amount;
        }
        else {
            contingencyTable[`${strike}`] = {
                strike: strike,
                CALL: optionType === types_1.OptionType.CALL ? amount : 0,
                PUT: optionType === types_1.OptionType.PUT ? amount : 0,
                netPosition: amount,
            };
        }
    }
    return contingencyTable;
};
exports.getContingencyTable = getContingencyTable;
const calculateAdjustedStrikePositions = (amount, strike, index) => {
    // TODO Env atm range 10%
    if (index * 0.9 < strike && strike < index * 1.1) {
        return amount * (Math.abs(index - strike) / (index * 0.1));
    }
    return amount;
};
